import React from 'react';
import { ArrayHelpers, Forms } from '@salesperformanceint/e4shared';
import './goalPicker.css';

export const GoalPicker = ({ label, error, mandatory, onChange, value, data, help }) => {
    React.useEffect(() => {
        if (value && ArrayHelpers.existsAndHasLength(data) && !data.some(x => x.id === value)) {
            onChange(null);
        }
    }, [value, data]);

    return (
        <Forms.Select
            data-testid="form-goal-picker"
            label={label}
            help={help}
            mandatory={mandatory}
            value={value}
            error={error}
            data={data}
            onChange={onChange}
        />
    );
};

export default GoalPicker;
